import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import { id as r } from "../../kernel.js";
import e from "../../request.js";
import { result as s } from "../../core/asyncUtils.js";
import o from "../../core/Error.js";
import i from "../../core/Logger.js";
import { isNone as a, isSome as l } from "../../core/maybe.js";
import { throwIfAborted as p, isAbortError as n, throwIfAbortError as m } from "../../core/promiseUtils.js";
import { normalize as u, hasSamePortal as c } from "../../core/urlUtils.js";
import { property as d } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { reader as h } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as f } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as y } from "../../core/accessorSupport/decorators/writer.js";
import g from "../../portal/Portal.js";
import I from "../../portal/PortalItem.js";
import j from "../../portal/PortalUser.js";

var v = i.getLogger("esri.layers.mixins.PortalLayer"),
    w = function w(i) {
  var w = /*#__PURE__*/function (_i) {
    _inherits(w, _i);

    var _super = _createSuper(w);

    function w() {
      var _this;

      _classCallCheck(this, w);

      _this = _super.apply(this, arguments), _this.resourceReferences = {
        portalItem: null,
        paths: []
      }, _this.userHasEditingPrivileges = !0;
      return _this;
    }

    _createClass(w, [{
      key: "destroy",
      value: function destroy() {
        var t;
        null == (t = this.portalItem) || t.destroy(), this.portalItem = null;
      }
    }, {
      key: "portalItem",
      set: function set(t) {
        t !== this._get("portalItem") && (this.removeOrigin("portal-item"), this._set("portalItem", t));
      }
    }, {
      key: "readPortalItem",
      value: function readPortalItem(t, r, e) {
        if (r.itemId) return new I({
          id: r.itemId,
          portal: e && e.portal
        });
      }
    }, {
      key: "writePortalItem",
      value: function writePortalItem(t, r) {
        t && t.id && (r.itemId = t.id);
      }
    }, {
      key: "loadFromPortal",
      value: function () {
        var _loadFromPortal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, r) {
          var _e;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(this.portalItem && this.portalItem.id)) {
                    _context.next = 14;
                    break;
                  }

                  _context.prev = 1;
                  _context.next = 4;
                  return import("../../portal/support/layersLoader.js");

                case 4:
                  _e = _context.sent;
                  p(r);
                  _context.next = 8;
                  return _e.load({
                    instance: this,
                    supportedTypes: t.supportedTypes,
                    validateItem: t.validateItem,
                    supportsData: t.supportsData
                  }, r);

                case 8:
                  return _context.abrupt("return", _context.sent);

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](1);
                  throw n(_context.t0) || v.warn("Failed to load layer (".concat(this.title, ", ").concat(this.id, ") portal item (").concat(this.portalItem.id, ")\n  ").concat(_context.t0)), _context.t0;

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[1, 11]]);
        }));

        function loadFromPortal(_x, _x2) {
          return _loadFromPortal.apply(this, arguments);
        }

        return loadFromPortal;
      }()
    }, {
      key: "finishLoadEditablePortalLayer",
      value: function () {
        var _finishLoadEditablePortalLayer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.t0 = this;
                  _context2.next = 3;
                  return this.fetchUserHasEditingPrivileges(t).catch(function (t) {
                    return m(t), !0;
                  });

                case 3:
                  _context2.t1 = _context2.sent;

                  _context2.t0._set.call(_context2.t0, "userHasEditingPrivileges", _context2.t1);

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function finishLoadEditablePortalLayer(_x3) {
          return _finishLoadEditablePortalLayer.apply(this, arguments);
        }

        return finishLoadEditablePortalLayer;
      }()
    }, {
      key: "fetchUserHasEditingPrivileges",
      value: function () {
        var _fetchUserHasEditingPrivileges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
          var e, s;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  e = this.url ? null == r ? void 0 : r.findCredential(this.url) : null;

                  if (e) {
                    _context3.next = 3;
                    break;
                  }

                  return _context3.abrupt("return", !0);

                case 3:
                  if (!(P.credential === e)) {
                    _context3.next = 7;
                    break;
                  }

                  _context3.t0 = P.user;
                  _context3.next = 10;
                  break;

                case 7:
                  _context3.next = 9;
                  return this.fetchEditingUser(t);

                case 9:
                  _context3.t0 = _context3.sent;

                case 10:
                  s = _context3.t0;
                  return _context3.abrupt("return", (P.credential = e, P.user = s, a(s) || null == s.privileges || s.privileges.includes("features:user:edit")));

                case 12:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function fetchUserHasEditingPrivileges(_x4) {
          return _fetchUserHasEditingPrivileges.apply(this, arguments);
        }

        return fetchUserHasEditingPrivileges;
      }()
    }, {
      key: "fetchEditingUser",
      value: function () {
        var _fetchEditingUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t) {
          var o, i, a, p, n, m, c, d, h;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  a = null == (o = this.portalItem) || null == (i = o.portal) ? void 0 : i.user;

                  if (!a) {
                    _context4.next = 3;
                    break;
                  }

                  return _context4.abrupt("return", a);

                case 3:
                  p = r.findServerInfo(this.url);

                  if (!(null == p || !p.owningSystemUrl)) {
                    _context4.next = 6;
                    break;
                  }

                  return _context4.abrupt("return", null);

                case 6:
                  n = "".concat(p.owningSystemUrl, "/sharing/rest"), m = g.getDefault();

                  if (!(m && m.loaded && u(m.restUrl) === u(n))) {
                    _context4.next = 9;
                    break;
                  }

                  return _context4.abrupt("return", m.user);

                case 9:
                  c = "".concat(n, "/community/self");
                  d = l(t) ? t.signal : null;
                  _context4.next = 13;
                  return s(e(c, {
                    authMode: "no-prompt",
                    query: {
                      f: "json"
                    },
                    signal: d
                  }));

                case 13:
                  h = _context4.sent;
                  return _context4.abrupt("return", h.ok ? j.fromJSON(h.value.data) : null);

                case 15:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function fetchEditingUser(_x5) {
          return _fetchEditingUser.apply(this, arguments);
        }

        return fetchEditingUser;
      }()
    }, {
      key: "read",
      value: function read(t, r) {
        r && (r.layer = this), _get(_getPrototypeOf(w.prototype), "read", this).call(this, t, r);
      }
    }, {
      key: "write",
      value: function write(t, r) {
        var e = r && r.portal,
            s = this.portalItem && this.portalItem.id && (this.portalItem.portal || g.getDefault());
        return e && s && !c(s.restUrl, e.restUrl) ? (r.messages && r.messages.push(new o("layer:cross-portal", "The layer '".concat(this.title, " (").concat(this.id, ")' cannot be persisted because it refers to an item on a different portal than the one being saved to. To save the scene, set the layer.portalItem to null or save the scene to the same portal as the item associated with the layer"), {
          layer: this
        })), null) : _get(_getPrototypeOf(w.prototype), "write", this).call(this, t, _objectSpread(_objectSpread({}, r), {}, {
          layer: this
        }));
      }
    }]);

    return w;
  }(i);

  return t([d({
    type: I
  })], w.prototype, "portalItem", null), t([h("web-document", "portalItem", ["itemId"])], w.prototype, "readPortalItem", null), t([y("web-document", "portalItem", {
    itemId: {
      type: String
    }
  })], w.prototype, "writePortalItem", null), t([d()], w.prototype, "resourceReferences", void 0), t([d({
    readOnly: !0
  })], w.prototype, "userHasEditingPrivileges", void 0), w = t([f("esri.layers.mixins.PortalLayer")], w), w;
},
    P = {
  credential: null,
  user: null
};

export { w as PortalLayer };